<template>
  <div class="boolean-toggle__wrapper">
    <div class="boolean-toggle">
      <div class="boolean-toggle__label-row">
        <span class="boolean-toggle__label">{{ label }}</span>
        <ShowHint v-if="hint" :hint="hint" />
        <div v-if="help" class="boolean-toggle__info-anchor">
          <button
            class="boolean-toggle__info-btn"
            :class="{ 'is-open': showHelp }"
            @click="showHelp = !showHelp"
            title="Ver explicação"
          >
            <CIcon name="cil-info" size="sm" />
          </button>
          <transition name="popover-fade">
            <div v-if="showHelp" class="boolean-toggle__popover" @click.stop>
              <div class="boolean-toggle__popover-arrow"></div>
              <div class="boolean-toggle__popover-body">
                {{ help }}
              </div>
              <button class="boolean-toggle__popover-close" @click="showHelp = false">&times;</button>
            </div>
          </transition>
        </div>
      </div>
      <label class="boolean-toggle__switch" :class="{ disabled: disabled }">
        <input
          type="checkbox"
          :checked="value"
          @change="$emit('input', $event.target.checked)"
          :disabled="disabled"
        />
        <span class="boolean-toggle__slider"></span>
        <span class="boolean-toggle__text">{{ value ? "Sim" : "Não" }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import ShowHint from "@/components/ShowHint.vue";

export default {
  name: "BooleanToggle",
  components: { ShowHint },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    help: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showHelp: false,
    };
  },
};
</script>

<style scoped>
.boolean-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.boolean-toggle__label-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.boolean-toggle__label {
  font-size: 13px;
  color: #333;
}

.boolean-toggle__info-anchor {
  position: relative;
  display: inline-flex;
}

.boolean-toggle__info-btn {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: #aaa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.boolean-toggle__info-btn:hover,
.boolean-toggle__info-btn.is-open {
  color: #3a3e81;
  background-color: rgba(58, 62, 129, 0.1);
}

.boolean-toggle__popover {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: 320px;
  background: #fff;
  border: 1px solid #dddce9;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 100;
  padding: 12px 14px;
}

.boolean-toggle__popover-arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 12px;
  background: #fff;
  border-left: 1px solid #dddce9;
  border-top: 1px solid #dddce9;
  transform: translateX(-50%) rotate(45deg);
}

.boolean-toggle__popover-body {
  font-size: 12px;
  color: #444;
  line-height: 1.6;
  padding-right: 16px;
}

.boolean-toggle__popover-close {
  position: absolute;
  top: 6px;
  right: 8px;
  background: none;
  border: none;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.boolean-toggle__popover-close:hover {
  color: #333;
}

.boolean-toggle__switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.boolean-toggle__switch.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.boolean-toggle__switch input {
  display: none;
}

.boolean-toggle__slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.boolean-toggle__slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.boolean-toggle__switch input:checked + .boolean-toggle__slider {
  background-color: #3a3e81;
}

.boolean-toggle__switch input:checked + .boolean-toggle__slider::after {
  transform: translateX(16px);
}

.boolean-toggle__text {
  font-size: 12px;
  color: #777;
  min-width: 28px;
}

.popover-fade-enter-active,
.popover-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.popover-fade-enter,
.popover-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-4px);
}
</style>
